module.exports = __webpack_public_path__ + "img/3x.a408bd7.jpg";